export enum MailingListsPath {
  add = "add",
  view = "view"
}

export const MailingListsTitle = {
  [MailingListsPath.add]: "Add",
  [MailingListsPath.view]: "View"
};
